import { EnumValue } from '../utils';

import { RouteType } from './route';

export const CUSTOM_SERVICE_TYPES = {
    TCP: 'TCP',
    UDP: 'UDP',
    ICMP: 'ICMP',
} as const;

export const SERVICE_TYPES = {
    Any: 'ANY',
    Custom: 'CUSTOM',
    BGP: 'BGP',
    DHCP: 'DHCP',
    DNS: 'DNS',
    FTP: 'FTP',
    HTTP: 'HTTP',
    HTTPS: 'HTTPS',
    IMAP: 'IMAP',
    IMAPS: 'IMAPS',
    NTP: 'NTP',
    POP3: 'POP3',
    POP3S: 'POP3S',
    SMTP: 'SMTP',
    SMTPS: 'SMTPS',
    SNMP: 'SNMP',
    SSH: 'SSH',
    TELNET: 'TELNET',
    TFTP: 'TFTP',

    friendlyString(entry: string): string {
        return (
            {
                [this.Any]: 'Any',
                [this.Custom]: 'Custom',
                [this.BGP]: 'BGP',
                [this.DHCP]: 'DHCP',
                [this.DNS]: 'DNS',
                [this.FTP]: 'FTP',
                [this.HTTP]: 'HTTP',
                [this.HTTPS]: 'HTTPS',
                [this.IMAP]: 'IMAP',
                [this.IMAPS]: 'IMAP over TLS/SSL',
                [this.NTP]: 'NTP',
                [this.POP3]: 'POP3',
                [this.POP3S]: 'POP3 over TLS/SSL',
                [this.SMTP]: 'SMTP',
                [this.SMTPS]: 'SMTP over TLS/SSL',
                [this.SNMP]: 'SNMP',
                [this.SSH]: 'SSH',
                [this.TELNET]: 'Telnet',
                [this.TFTP]: 'TFTP',
            }[entry] || entry
        );
    },
} as const;

export const SERVICE_TYPE = {
    Source: 'IP_SOURCE',
    Destination: 'SERVICE_DESTINATION',
} as const;

export type RouteT = EnumValue<typeof RouteType>;

export type CustomServiceType = EnumValue<typeof CUSTOM_SERVICE_TYPES>;

export type ServiceType = EnumValue<typeof SERVICE_TYPES>;

export type IPSource = typeof SERVICE_TYPE.Source;

export type ServiceDestination = typeof SERVICE_TYPE.Destination;

export type IPServiceType = IPSource | ServiceDestination;

type DecodedPortRange = {
    l: number;
    r?: number;
};

type DecodedCustomServiceConfig = {
    t: CustomServiceType;
    p?: DecodedPortRange[];
};

export type DecodedServiceProtocol = {
    routeType: RouteT;
    ip: string; // ipv4, ipv6, domain
    st: ServiceType[];
    cst: DecodedCustomServiceConfig[];
};
